import type { SectionView, StepView } from '~/helpers/learner/session-view'
import { stepStatus } from '~/helpers/learner/session-view'

export type ChapterSlice = {
  /** Null : étapes sans chapitre — tout le parcours s'il n'en a aucun, sinon celles d'avant le premier. */
  section: SectionView | null
  steps: StepView[]
  /** Étapes terminées du chapitre : son avancement, « 1 / 3 terminés ». */
  done: number
}

/**
 * Les étapes d'un parcours groupées par chapitre (#75), dans l'ordre du parcours.
 *
 * Un chapitre est une tranche CONTIGUË de la liste (l'API le garantit) : il
 * suffit de couper la liste à chaque changement de chapitre. Un parcours sans
 * chapitre rend une seule tranche, sans titre — l'écran reste celui d'avant.
 */
export function chapterSlices(steps: StepView[], sections: readonly SectionView[]): ChapterSlice[] {
  const byId = new Map(sections.map(section => [section.id, section]))
  const slices: ChapterSlice[] = []
  for (const step of steps) {
    const section = (step.sectionId && byId.get(step.sectionId)) || null
    const last = slices.at(-1)
    if (last && last.section?.id === section?.id) last.steps.push(step)
    else slices.push({ section, steps: [step], done: 0 })
  }
  for (const slice of slices) {
    slice.done = slice.steps.filter(step => stepStatus(step) === 'COMPLETED').length
  }
  return slices.length > 0 ? slices : [{ section: null, steps: [], done: 0 }]
}
